// Resize is not available after the migration to the new CDN
const RESIZE_AVAILABLE = false;

const getImageUrl = (url: string, width: number) => {
  if (!url) return "";
  if (width && RESIZE_AVAILABLE) {
    const newUrl = new URL(url);
    return newUrl.origin + "/resize=width:" + width + newUrl.pathname;
  }
  return url;
};

export default getImageUrl;
